






















































































































































import Vue from 'vue';
import { editor, terminal, registers, memory, instruction, tutorial, settings } from "@/vue";
import { SimulatorState } from "@/simulator";
import { Interpreter, RuntimeError } from '@/interpreter';
import { Register, EnvironmentType } from "@/constants"
import { createTour, SettingsState } from '@/utilities';

import './assets/generic.css';
import './assets/syntax.css';
import './assets/shepherd.css';

import { TInstructionNode } from '@/syntax/types';
import Shepherd from 'shepherd.js';
import { FileSystemState } from './files';

export default Vue.extend({
  name: 'emulator',
  components: {
    editor,
    terminal,
    registers,
    memory,
    instruction,
    tutorial, 
    settings
  },
  data() {
    return {
      env: EnvironmentType.TERMINAL,

      dismissTooSmall: false,
      windowSize: 0
    }
  },
  computed: {
    currentTick: SimulatorState.currentTick,

    // registers: SimulatorState.registers,
    // breakpoints: SimulatorState.breakpoints,
    errors: SimulatorState.errors,
    errorSummary: function (): string[] {
      return this.errors.map(e => `${e.constructHelperHTML()}`)
    },
    
    running: SimulatorState.running,
    paused: SimulatorState.paused,
    // step: SimulatorState.step,

    isTooSmall: function (): boolean {
      return !this.dismissTooSmall && this.windowSize < 1250;
    },

    // hack so we can access the enum in dom
    EnvironmentType: () => EnvironmentType,
  },
  methods: {
    /**
     * 
     */
    switchEnvironment: function () {
      if (this.env === EnvironmentType.TERMINAL) this.env = EnvironmentType.EDITOR;
      else this.env = EnvironmentType.TERMINAL;

      localStorage.setItem('environment', this.env);
    },

    startTour: function () {
      this.env = EnvironmentType.TERMINAL;
      createTour().start();

      Shepherd.activeTour?.once(
        'complete', 
        () => { 
          localStorage.setItem('doneTour', 'true');
          SimulatorState.reset(); 
        });
    },

    windowSizeListener: function () {
      this.windowSize = window.innerWidth;
    },

    keyListener: function (e: KeyboardEvent) {
      if (this.env !== EnvironmentType.EDITOR) return;

      if (e.code === "ArrowDown" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        
        if (!this.running) {
          SimulatorState.start();
        }
        else {
          if (this.paused) SimulatorState.resume();
          else SimulatorState.pause();
        }
      }

      else if (e.code === "ArrowUp" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        SimulatorState.stop();
      }

      else if (e.code === "ArrowRight" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        SimulatorState.stepForward();
      }

      else if (e.code === "ArrowLeft" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        SimulatorState.stepBack();
      }
    }
  },

  created: function () {
    SettingsState.init();
    SimulatorState.init();
    FileSystemState.init();
    SimulatorState.setVueInstance(this)

    window.addEventListener("resize", this.windowSizeListener);
    this.windowSizeListener();
  },

  mounted: function () {
    document.addEventListener('keydown', this.keyListener.bind(this));

    let doneTour = localStorage.getItem('doneTour') ?? false;
    if (!doneTour) this.startTour();
    else {
      this.env = (localStorage.getItem('environment') as EnvironmentType) ?? EnvironmentType.TERMINAL;

      // hack to prompt editor to load any code from localStorage on refresh
      this.switchEnvironment();
      this.$nextTick(() => this.switchEnvironment());
    }
  },

  beforeDestroy: function () {
    window.removeEventListener("resize", this.windowSizeListener);
    document.removeEventListener('keydown', this.keyListener);
  },

  watch: {
    crtEffect: function (on: boolean) {
      const element: Element = document.getElementsByTagName('html')[0];
      if (on) element.classList.add("crt");
      else element.classList.remove("crt");
    }
  }
})
